import { env } from './env';

export const setCookie = (name: string, value: string, days: number) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}; path=/; domain=.${env.VITE_FRONTEND_CORE_HOSTNAME}; expires=${expires}; SameSite=Lax; Secure`;
};

export const getCookie = (name: string) => {
  const nameEQ = `${name}=`;
  const cookiesArray = document.cookie.split(';');
  for (let i = 0; i < cookiesArray.length; i += 1) {
    let cookie = cookiesArray[i];
    while (cookie.charAt(0) === ' ')
      cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0)
      return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
};

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  cookies.forEach((cookie) => {
    const [name] = cookie.split('=');
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${env.VITE_FRONTEND_CORE_HOSTNAME}`;
  });
};
